<template>
  <div id="ServiceCodeAddEdit">
    <b-modal id="loadingmodel" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close
      hide-footer>
      <div slot="default">
        <div class="alert alert-danger" role="alert">
          We are processing your request, please wait.... <br />
        </div>
        <div class="text-center justify-content-center row col-12">
          <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize"
            :sizeUnit="unit"></ring-loader>
          <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize"
            :sizeUnit="unit"></rise-loader>
          <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize"
            :sizeUnit="unit"></ring-loader>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-lg" class="test-modal" size="lg" title="Manage Service Code" v-model="showModal" no-close-on-esc
      no-close-on-backdrop hide-header-close>
      <div slot="default">
        <div class="alert alert-warning" role="alert" v-if="!succeeded">
          {{ Msg }}
        </div>
        <div class="alert alert-success" role="alert" v-if="succeeded">
          {{ Msg }}
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary" size="md" class="float-right BtnClose" @click="ServiceCodeExit">
          Close
        </b-button>
      </div>
    </b-modal>
    <div class="row mr-0">
      <div class="col-3 m-0 p-0 pl-1">
        <div class="row">
          <div class="col-5">
            <label for="ServiceCode" class="label-small">Service Code:</label>
          </div>
          <div class="col-7">
            <input id="ServiceCode" :disabled="!AllowEdit || Mode == 'Edit'" v-model="serviceCode" maxlength="10" type="text"
              placeholder="Service Code" class="mb-1 form-control form-control-xs" ref="Sctxt" @keyup="getScValue" />
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.serviceCode.$error">
            <small class="sml-red" v-if="!$v.serviceCode.needValue">Service Code is required</small>
            <small class="sml-red" v-if="!$v.serviceCode.maxlength">Service Code length is invalid</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="ServiceDescription" class="label-small p-0 m-0">Service Description:</label>
          </div>
          <div class="col-7">
            <textarea v-model="textDescription" :disabled="!AllowEdit" wrap="on" rows="3" max="42" maxlength="128"
              id="ServiceDescription" placeholder="Service Description" class="mb-1 form-control text-area-xs"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.textDescription.$error">
            <small class="sml-red" v-if="!$v.textDescription.required">Service Code description is required</small>
            <small class="sml-red" v-if="!$v.textDescription.maxlength">Description length is invalid</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="EffectiveDate" class="label-small p-0 m-0">Effective Date:</label>
          </div>
          <!-- Enable back dating :disabledDates="{ to: new Date(Date.now() - 8640000) }" -->
          <div class="col-7">
            <!-- typeable -->
            <datepicker :disabled="!AllowEdit" :open-date="new Date()" v-model="effectiveDate" :format="dateFormat"
              id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker>
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.effectiveDate.$error">
            <small class="sml-red" v-if="!$v.effectiveDate.required">Effective date is required</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="ExpiryDate" class="label-small p-0 m-0">Expiry Date:</label>
          </div>
          <div class="col-7">
            <!-- typeable -->
            <!-- :disabledDates="{ to: new Date(Date.now() - 8640000) }" -->
            <datepicker :disabled="!AllowEdit && !AllowEditExpiryDate" :open-date="new Date()" v-model="expiryDate"
              :format="dateFormat" id="expDate" :bootstrap-styling="true" :input-class="datapickClass"
              name="effectiveDatepicker"></datepicker>
          </div>
        </div>
        <div class="row" v-if="AllowEdit || AllowEditExpiryDate">
          <div class="col-5"></div>
          <div class="col-7 mt-1 ml-0 pl-2">
            <template>
              <RadioToggleButtons class="form-control-sm" v-model="expiryDate" :values="OpenEndedDate" color="#006537"
                textColor="#000" selectedTextColor="#fff" /><span v-on:click="expiryDate = ''" style="font-size: 1em;"><i
                  class="fas fa-times ml-2 pointer"></i>
              </span>
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.expiryDate.$error">
            <small class="sml-red" v-if="!$v.expiryDate.required">Expiry date is required.</small>
            <small class="sml-red" v-if="!$v.expiryDate.minValue1">Expiry Date can't be in the past.</small>
            <small class="sml-red" v-if="!$v.expiryDate.minValue2">Expiry Date must not be before the effective
              date.</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label class="label-small p-0 m-0">Service Type:</label>
          </div>
          <div></div>
          <div class="col-7 mt-1">
            <div class="row ml-1" v-for="serv in ServiceTypes" :key="serv.id">
              <div class="checkbox">
                <label>
                  <input id="ServCheck" :disabled="!AllowEdit || Mode == 'Edit'" type="checkbox" class="pointer"
                    @change="changedServiceTypechkbox()" :value="serv" v-model="SelectedServices" />
                  <span class="cr"><i class="cr-icon fas fa-check"></i></span>
                  <span style="vertical-align: top"><b>{{ serv.text }} ({{ serv.type }})</b></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.SelectedServices.$error">
            <small class="sml-red" v-if="!$v.SelectedServices.needValue">Please Select Service Type.</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label class="label-small p-0 m-0">Service Sub Type:</label>
          </div>
          <div class="col-7 mt-1">
            <div class="row ml-1" v-for="serv in ServiceSubTypes" :key="serv.id">
              <div class="checkbox">
                <label>
                  <input id="ServSubCheck" :disabled="!AllowEdit" type="checkbox" class="pointer"
                    @change="changedSubTypeschkbox()" :value="serv" v-model="SelectedSubTypes" />
                  <span class="cr"><i class="cr-icon fas fa-check"></i></span>
                  <span style="vertical-align: top">{{ serv.text }} ({{ serv.type }})</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.SelectedSubTypes.$error">
            <small class="sml-red" v-if="!$v.SelectedSubTypes.required">Please Select Service Sub Type.</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="MaxRegAmmounts" class="label-small p-0 m-0">
              Max Allowable Amount:</label>
          </div>
          <div class="col-7">
            <input :disabled="!AllowEdit" maxlength="9" name="MaxRegAmount" class="form-control form-control-xs"
              v-model="maxChargeAmt" />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-5">
            <label for="Retired" class="label-small p-0 m-0">
              Is Retired :</label>
          </div>
          <div class="col-7">
            <toggle-button :disabled="!AllowEdit" v-model="IsRetired" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />
          </div>
        </div>

        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.maxChargeAmt.$error">
            <small class="sml-red" v-if="!$v.maxChargeAmt.required">Max Regular Amount is required</small>
            <small class="sml-red" v-if="!$v.maxChargeAmt.SixvTwo && $v.maxChargeAmt.required">Max Regular Amount must be
              between 0.000 and 999,999.99 and have
              up to 2 decimals</small>
          </div>
        </div>
        <div class="row" v-show="ShowNonDental">
          <div class="col-5">
            <label for="MarkupPCT" class="label-small p-0 m-0">Mark-up Percentage:</label>
            &nbsp;
          </div>
          <div class="col-7">
            <input placeholder="##.#" :disabled="!AllowEdit" maxlength="5" type="text"
              class="form-control form-control-xs" id="MarkupPCT" v-model="pctMaxMarkup" />
          </div>
        </div>
        <div class="form-group row my-0" v-show="ShowNonDental">
          <div class="col-sm-5"></div>
          <div class="col-sm-7 sml-red pl-3">
            <b>Format : 15% is 0.150 </b>
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.pctMaxMarkup.$error">
            <small class="sml-red" v-if="!$v.pctMaxMarkup.needValue">Mark-up Percentage is required</small>
            <small class="sml-red" v-if="!$v.pctMaxMarkup.OnevThree">Mark-up Percentage must be between 0.000 and 1.000
              and have up to
              3 decimals</small>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row mt-0">
          <div class="col-5">
            <label for="PAReq" class="label-small p-0 m-0">Prior Approval Requirement:</label>
          </div>
          <div class="col-7">
            <select :disabled="!AllowEdit" id="PAReq" @change="PAReqChange($event)" v-model="PAReq"
              class="m-0 p-0 form-control form-control-xs">
              <option v-for="option in PACodes" v-bind:value="option.id" :key="option.id">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="PADuration" class="label-small p-0 m-0">Prior Approval Duration:</label>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div class="small">Unit:</div>
                <select :disabled="!AllowEdit || PAReq == 'NA'" id="PADuration" v-model="PADuration"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in PADurationCodes" v-bind:value="{ id: option.id, text: option.text }"
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-7">
                <div class="small">Length:</div>
                <input :disabled="!AllowEdit || PAReq == 'NA'" id="numUnitPA" v-model="numUnitPriorApproval" maxlength="3"
                  type="text" placeholder="Length" class="mb-1 form-control form-control-xs" />
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutter m-0 p-0">
          <!-- {{ numUnitPriorApproval }} -->
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row no-gutter">
              <div class="col-5">
                <div v-show="$v.PADuration.$error">
                  <small class="sml-red" v-if="!$v.PADuration.Valrequired">Unit is required</small>
                </div>
              </div>
              <div class="col-7">
                <div v-show="$v.numUnitPriorApproval.$error">
                  <small class="sml-red" v-if="!$v.numUnitPriorApproval.Valrequired">Length is required</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- {{ numUnitPriorApprovalFrequency }} -->
          <div class="col-5">
            <label for="NumberBeforePriorApproval" class="label-small p-0 m-0">Number Before Prior Approval:</label>
          </div>
          <div class="col-7">
            <input :disabled="!AllowEdit || PAReq == 'NA'" id="NumberBeforePriorApproval"
              v-model="numUnitPriorApprovalFrequency" maxlength="3" type="number"
              placeholder="Number Before Prior Approval" class="mb-1 form-control form-control-xs" />
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.numUnitPriorApprovalFrequency.$error">
            <small class="sml-red" v-if="!$v.numUnitPriorApprovalFrequency.Valrequired">Number Before Prior Approval is
              required</small>
            <!-- <small class="sml-red" v-if="!$v.numUnitPriorApprovalFrequency.numeric">Number Before Prior Approval must be a number</small> -->
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="BillFrequency" class="label-small">Bill Frequency:</label>
          </div>
          <div class="col-7">
            <div class="row no-gutters">
              <div class="col-4">
                <div class="small">Unit:</div>
                <select :disabled="!AllowEdit" id="BillFrequency" v-model="BillFrequency"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in BillFrequencyCodes" v-bind:value="{ id: option.id, text: option.text }"
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-4">
                <div class="small">No. of Units:</div>
                <input :disabled="!AllowEdit" id="numBillFreq" v-model="numBillFreq" maxlength="3" type="text"
                  placeholder="No. of Units" class="mb-1 form-control form-control-xs" />
              </div>
              <div class="col-4">
                <div class="small">Max Qty/Freq:</div>
                <input :disabled="!AllowEdit" id="maxfreq" v-model="numQtyMaxBill" maxlength="3" type="text"
                  placeholder="Max Qty/Frequency" class="mb-1 form-control form-control-xs" />
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutter m-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row no-gutters">
              <div class="col-4">
                <div v-show="$v.BillFrequency.$error">
                  <small class="sml-red" v-if="!$v.BillFrequency.Valrequired">Unit is required</small>
                </div>
              </div>
              <div class="col-4">
                <div v-show="$v.numBillFreq.$error">
                  <small class="sml-red" v-if="!$v.numBillFreq.required">Unit no is required</small>
                  <small class="sml-red" v-if="!$v.numBillFreq.numeric">must be a number</small>
                </div>
              </div>
              <div class="col-4">
                <div v-show="$v.numQtyMaxBill.$error">
                  <small class="sml-red" v-if="!$v.numQtyMaxBill.required">Qty is required</small>
                  <small class="sml-red" v-if="!$v.numQtyMaxBill.numeric">must be a number</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="PurgeFreq" class="label-small p-0 m-0">Purge Frequency:</label>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div class="small">Unit:</div>
                <select id="PurgeFreq" :disabled="!AllowEdit" v-model="PurgeFrequency"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in PurgeFrequencyCodes" v-bind:value="{ id: option.id, text: option.text }"
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-7">
                <div class="small">Length:</div>
                <input :disabled="!AllowEdit" id="numUnitPurgeFrequency" v-model="numUnitPurgeFrequency" maxlength="3"
                  type="text" placeholder="Length" class="mb-1 form-control form-control-xs" />
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutter m-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div v-show="$v.PurgeFrequency.$error">
                  <small class="sml-red" v-if="!$v.PurgeFrequency.Valrequired">Unit is required</small>
                </div>
              </div>
              <div class="col-7">
                <div v-show="$v.numUnitPurgeFrequency.$error">
                  <small class="sml-red" v-if="!$v.numUnitPurgeFrequency.required">Length is required e.g(1/2)</small>
                  <small class="sml-red" v-if="!$v.numUnitPurgeFrequency.numeric">must be a number</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <label for="MinAge" class="label-small">Min Age:</label>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div class="small">Unit:</div>
                <select :disabled="!AllowEdit" id="MinAgeDurationCodes" v-model="MinAge"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in AgeDurationCodes" v-bind:value="{ id: option.id, text: option.text }"
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-7">
                <div class="small">Length:</div>
                <input :disabled="!AllowEdit" id="numAgeMin" v-model="numAgeMin" maxlength="3" type="text"
                  placeholder="Length" class="mb-1 form-control form-control-xs" />
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutter m-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div v-show="$v.MinAge.$error">
                  <small class="sml-red" v-if="!$v.MinAge.Valrequired">Unit is required</small>
                </div>
              </div>
              <div class="col-7">
                <div v-show="$v.numAgeMin.$error">
                  <small class="sml-red" v-if="!$v.numAgeMin.required">Length is required e.g(1/2)</small>
                  <small class="sml-red" v-if="!$v.numAgeMin.numeric">must be a number</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <label for="MaxAge" class="label-small">Max Age:</label>
          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div class="small">Unit:</div>
                <select :disabled="!AllowEdit" id="MaxAgeDurationCodes" v-model="MaxAge"
                  class="m-0 p-0 form-control form-control-xs">
                  <option v-for="option in AgeDurationCodes" v-bind:value="{ id: option.id, text: option.text }"
                    :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-7">
                <div class="small">Length:</div>
                <input :disabled="!AllowEdit" id="numAgeMax" v-model="numAgeMax" maxlength="3" type="text"
                  placeholder="Length" class="mb-1 form-control form-control-xs" />
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutter m-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row">
              <div class="col-5">
                <div v-show="$v.MaxAge.$error">
                  <small class="sml-red" v-if="!$v.MaxAge.Valrequired">Unit is required</small>
                </div>
              </div>
              <div class="col-7">
                <div v-show="$v.numAgeMax.$error">
                  <small class="sml-red" v-if="!$v.numAgeMax.required">Length is required e.g(1/2)</small>
                  <small class="sml-red" v-if="!$v.numAgeMax.numeric">must be a number</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-5 small">General Coverage Plans:</div>
          <div class="col-7 row" style="padding-left:1.7rem; justify-content: center; !important">
            <div class="mr-1" v-for="serv in GCCodes" :key="serv.id">
              <div class="checkbox form-control-xs">
                <label>
                  <input id="ServSubCheck" :disabled="!AllowEdit" type="checkbox" class="pointer" :value="serv"
                    v-model="GC" />
                  <span class="cr"><i class="cr-icon fas fa-check"></i></span>
                  <span class="" style="vertical-align: top">{{ serv.text }}
                  </span>
                </label>
              </div>
            </div>
          </div>
          <hr class="mt-2 w-100" />
        </div>

        <div class="row no-guttersm-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row n-gutters">
              <div class="col-12">
                <div v-show="$v.GC.$error">
                  <small class="sml-red" v-if="!$v.GC.required">Must select at least one plan</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <label for="MaxAge" class="label-small">Special Category:</label>
          </div>
          <div class="col-7">
            <div class="row no-gutters">
              <div class="col-5">
                <div class="small">Category:</div>
                <select class="form-control form-control-xs my-0" :disabled="!AllowEdit" v-model="nameCategory"
                  @change="handleCategoryChange">Dental Cleaning
                  <option value=" ">N/A</option>
                  <option value="FILM">Film</option>
                  <option value="ORTH">Orthodontics</option>
                  <option value="BATT">Battery</option>
                  <option value="DSCA">Dental Scaling</option>
                  <option value="DPOL">Dental Polishing</option>
                </select>
              </div>
              <div class="col-2">
                <div class="small">Qty:</div>
                <input :disabled="!AllowEdit" type="text" maxlength="3" class="mb-1 form-control form-control-xs"
                  id="categoryquantity" v-model="numUnitCategory" />
              </div>
              <div class="col-5">
                <div class="small">Category Period:</div>
                <select class="form-control form-control-xs my-0" :disabled="!AllowEdit" v-model="codeCategoryPeriod"
                  @change="handleCategoryPeriodChange">
                  <option value=" ">N/A</option>
                  <option value="RUNTOT">Running Total</option>
                  <option value="ROLL06">6-month Rolling</option>
                  <option value="ROLL12">12-month Rolling</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row no-guttersm-0 p-0">
          <div class="col-5"></div>
          <div class="col-7">
            <div class="row n-gutters">
              <div class="col-5"></div>
              <div class="col-7">
                <div v-show="$v.numUnitCategory.$error">
                  <small class="sml-red" v-if="!$v.numUnitCategory.required">Qty is required</small>
                  <small class="sml-red" v-if="!$v.numUnitCategory.numeric">Qty must be a number</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-show="ShowNonDental">
          <div class="col-5">
            <label for="ShippingInd" class="label-small p-0 m-0">Shipping:</label>
            &nbsp;
          </div>
          <div class="col-2">
            <div class="row m-0">
              <toggle-button :disabled="!AllowEdit" v-model="codeIndShipRadio" v-on:change="ShippingChange()"
                :switch-color="{
                  checked: '#25EF02',
                  unchecked: 'linear-gradient(red, yellow)',
                }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />&nbsp;
            </div>
          </div>
          <div class="col-1">
            <div class="row m-0">
              <label for="ShippingMax" class="label-small mr-3">Amount:</label>
              &nbsp;
            </div>
          </div>
          <div class="col-4">
            <div class="row ml-3">
              <input :disabled="!AllowEdit || allowShip" maxlength="9" type="text" style="width: 75%"
                class="form-control form-control-xs my-0 ml-3" id="ShippingMax" v-model="amtChargeShipMax" />
            </div>
          </div>
        </div>

        <div class="row" v-show="ShowNonDental">
          <div class="col-6"></div>
          <div class="col-6" v-show="$v.amtChargeShipMax.$error">
            <small class="sml-red" v-if="!$v.amtChargeShipMax.amtChargeShipMaxNeeded">Shpping amount required</small>
            <small class="sml-red" v-if="!$v.amtChargeShipMax.SixvTwo">Mmust be avlid number e.g (20.00)</small>
          </div>
        </div>
        <div class="row" v-show="ShowNonDental">
          <div class="col-5">
            <label for="ShippingMax" class="label-small p-0 m-0">Tax Code:</label>
          </div>
          <div class="row col-7" style="padding-left:1.3rem; !important">
            <div class="ml-1" v-for="tx in Taxes" :key="tx.id">
              <div class="checkbox form-control-xs">
                <label>
                  <input id="tx" :disabled="!AllowEdit" type="checkbox" class="pointer" :value="tx.id"
                    v-model="codeTaxes" />
                  <span class="cr"><i class="cr-icon fas fa-check"></i></span>
                  <span style="vertical-align: top">{{ tx.text }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-5">
        <div class="row">
          <div class="col-5">
            <label for="SurchargeAllowed" class="label-small p-0 m-0">Surcharge Allowed:</label>
          </div>
          <div class="col-7">
            <toggle-button @change="SurchargeChange($event)" :disabled="!AllowEdit" v-model="codeIndSurchargeRadio"
              :switch-color="{
                checked: '#25EF02',
                unchecked: 'linear-gradient(red, yellow)',
              }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="SurchargePercentage" class="label-small p-0 m-0">Surcharge Percentage:</label>
          </div>
          <div class="col-7">
            <input :disabled="!AllowEdit || codeIndSurchargeRadio == false" type="text" maxlength="5"
              class="form-control form-control-xs" id="SurchargePercentage" v-model="pctMaxSurcharge" />
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.pctMaxSurcharge.$error">
            <small class="sml-red" v-if="!$v.pctMaxSurcharge.Valrequired">Surcharge Percentage is required</small>
            <small class="sml-red" v-if="!$v.pctMaxSurcharge.OnevThree && $v.pctMaxSurcharge.required
              ">Surcharge Percentage must be between 0.000 and 1.000 and have up
              to 3 decimals</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="SurchargeAmount" class="label-small p-0 m-0">Surcharge Max Amount:</label>
          </div>
          <div class="col-7">
            <input :disabled="!AllowEdit || codeIndSurchargeRadio == false" type="text" maxlength="9"
              class="form-control form-control-xs" id="SurchargeAllowed" v-model="amtMaxSurcharge" />
          </div>
        </div>
        <div class="row">
          <div class="col-5"></div>
          <div class="col-7" v-show="$v.amtMaxSurcharge.$error">
            <small class="sml-red" v-if="!$v.amtMaxSurcharge.Valrequired">Max Regular Amount is required</small>
            <small class="sml-red" v-if="!$v.amtMaxSurcharge.SixvTwo && $v.amtMaxSurcharge.required">Max Regular Amount
              must be between 0.000 and 999,999.99 and have
              up to 2 decimals</small>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label for="AttachmentRequired" class="label-small p-0 m-0">Attachment Required :</label>
          </div>
          <div class="col-7 no-gutters">
            <label for="btn" class="label-xsmall p-0 m-0"> </label>
            <div class="float-left p-0 m-0 no-gutters" id="atachbtn" style="padding:0px; margin:0px; !important">
              <template class="p-0 m-0 no-gutters">
                <RadioToggleButtons v-model="codeIndAttachRadio" :values="AttachValues" color="#006537" textColor="#000"
                  selectedTextColor="#fff" />
              </template>
            </div>
            <!-- <toggle-button :disabled="!AllowEdit" v-model="codeIndAttachRadio" :switch-color="{checked: '#25EF02', unchecked: 'linear-gradient(red, yellow)'}" :value="false" color="#82C7EB" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/> -->
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <label for="LTCBillable" class="label-small p-0 m-0">Long Term Care Billable:</label>
          </div>
          <div class="col-7">
            <toggle-button :disabled="!AllowEdit" v-model="codeIndLTCRadio" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ServiceCodePrereqServiceCodes :key="ServiceKey" :Data="prerequisiteCodes" :CurrentCode="serviceCode"
              :Codes="SelectedServices" :ReadOnly="!AllowEdit"></ServiceCodePrereqServiceCodes>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ServiceCodeContradictory ref="RefScContra" :key="ServiceKey" :Data="contradictoryCodes"
              :CurrentCode="serviceCode" :CurrentCodeDesc="textDescription" :Codes="SelectedServices"
              :ReadOnly="!AllowEdit"></ServiceCodeContradictory>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ServiceCodeGRPSpecRate :key="SubTypeKey" :Data="grpSpecRates" :LookUp="SelectedSubTypes"
              :ReadOnly="!AllowEdit"></ServiceCodeGRPSpecRate>
          </div>
        </div>
        <div class="row" v-show="ShowDental">
          <div class="col-5">
            <label for="SurchargeAllowed" class="label-small p-0 m-0">Tooth Number Required:</label>
          </div>
          <div class="col-7">
            <label for="btn" class="label-small"> </label>
            <div class="float-left" id="btn">
              <template>
                <RadioToggleButtons v-on:change="changedToothRequired()" v-model="codeIndToothRadio"
                  :values="ToothReqValues" color="#006537" textColor="#000" selectedTextColor="#fff" />
              </template>
            </div>
          </div>
        </div>

        <div class="row" v-show="ShowDental">
          <div class="col-12">
            <ServiceCodeToothNumberAllowed :key="TeethKey" :Data="numTeeth" :AllowAdd="codeIndToothRadio"
              :ReadOnly="!AllowEdit"></ServiceCodeToothNumberAllowed>
          </div>
        </div>
        <div class="row" v-show="ShowDental">
          <div class="col-5">
            <label for="EDCEligibility" class="label-small p-0 m-0">Emergency Dental Coverage Eligibility:</label>
          </div>
          <div class="col-7">
            <toggle-button class="small" :disabled="!AllowEdit" v-model="codeIndEDCEligRadio" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />
          </div>
        </div>
        <div class="row" v-show="ShowDental">
          <div class="col-5">
            <label for="OrthoLetter" class="label-small p-0 m-0">Generate Ortho Letter:</label>
          </div>
          <div class="col-7">
            <toggle-button class="small" :disabled="!AllowEdit" v-model="codeIndLetterRadio" :switch-color="{
              checked: '#25EF02',
              unchecked: 'linear-gradient(red, yellow)',
            }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" />
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row" style="bottom: 10px">
      <div class="col-2"></div>
      <div class="col-3 p-0 m-0">
        <div v-if="mode != 'View'">
          <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave btn-sml">
            <i :class="saveIcon"></i> {{ btnName }}
          </button>
        </div>
      </div>
      <div class="col-2 p-0 m-0">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right">
          <i class="fas fa-times"></i> Close Form
        </button>
      </div>
      <div class="col-5"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import moment, { relativeTimeRounding } from "moment";
//import moment from 'moment'
import ServiceCodeGRPSpecRate from "@/components/DPEBB/Administrator/ServiceCodeGRPSpecRate.vue";
import ServiceCodePrereqServiceCodes from "@/components/DPEBB/Administrator/ServiceCodePrereqServiceCodes.vue";
import ServiceCodeSAIL from "@/components/DPEBB/Administrator/ServiceCodeSAIL.vue";
import ServiceCodeToothNumberAllowed from "@/components/DPEBB/Administrator/ServiceCodeToothNumberAllowed.vue";
import ServiceCodeContradictory from "@/components/DPEBB/Administrator/ServiceCodeContradictory.vue";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import { RingLoader } from '@saeris/vue-spinners';
import { RiseLoader } from '@saeris/vue-spinners';

import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  email,
  numeric,requiredIf
} from "vuelidate/lib/validators";
const SixvTwo = helpers.regex("alphaNum", /^[0-9]{0,6}(\.[0-9]{1,2})?$/);
const OnevThree = helpers.regex(
  "alphnum",
  /^1{1}(\.[0]{1,3})?$|^0{0,1}(\.[0-9]{1,3})?$/
);
const OnevFour = helpers.regex("alphnum", /^[0-2]{0,1}(\.[0-2]{1,3})?$/);

Vue.use(Vuelidate);
export default {
  props: {
    PropServiceCode: "",
    Mode: "",
    status: "",
  },
  data: function () {
    return {
        loading: false,
        size: 250,
        Ringsize: 40,
        Risesize: 12,
        margin :'2px',
        unit: 'px',
        color:'#bada55',

      IsRetired: false,
      OpenEndedDate: [
        { label: "Expiry: Open Ended Date", value: "9999/12/31" },
      ],
      AllowEdit: false,
      AllowEditExpiryDate: false,
      isSuper: false,
      AttachValues: [
        { label: "No", value: "N" },
        { label: "Claim", value: "C" },
        { label: "PA", value: "P" },
        { label: "Both", value: "B" },
      ],
      ToothReqValues: [
        { label: "None", value: "0" },
        { label: "One", value: "1" },
        { label: "One+", value: "9" },
        { label: "Two +", value: "2" },
      ],
      disableSave: false,
      btnName: "Edit Service Code",
      saveIcon: "fas fa-plus",
      ObjServiceCode: "",
      codeIndRegiem: "N",
      serviceCode: "",
      textDescription: "",
      modifyUserId: "",
      createdDate: "",
      lastmodifiedDate: "",
      viewOnly: false,
      effectiveDate: "",
      expiryDate: "",
      serviceSubTypes: [],
      serviceSubTypesIndex: [],
      maxChargeAmt: "",
      grpSpecRates: [],
      codePriorApproval: "",
      codeUnitPADuration: "",
      numUnitPriorApproval: "0",
      numUnitPriorApprovalFrequency: "0",
      numBillFreq: "",
      numQtyMaxBill: "",
      codeUnitAgeMin: "",
      numAgeMin: "",
      codeUnitAgeMax: "",
      numAgeMax: "",
      codeCovPlans: [],
      Taxes: [],
      prerequisiteCodes: [],
      codeIndSurcharge: "",
      codeIndSurchargeRadio: false,
      pctMaxSurcharge: "0.000",
      amtMaxSurcharge: "0",
      codeIndAttach: "",
      codeIndAttachRadio: "N",
      codeIndLTC: "",
      codeIndLTCRadio: false,
      numUnitPurgeFrequency: "",
      codeIndTooth: "",
      codeIndToothRadio: "0",
      numTeeth: [],
      codeIndEDCElig: "",
      codeIndEDCEligRadio: false,
      contradictoryCodes: [],
      nameCategory: " ",
      numUnitCategory: "0",
      codeCategoryPeriod: " ",
      codeIndLetter: "",
      codeIndLetterRadio: false,
      codeIndShip: "",
      codeIndShipRadio: false,
      amtChargeShipMax: "0",
      pctMaxMarkup: "0",
      TeethPerClaim: "",
      codeTaxes: [],
      sailCodes: [],
      readonly: false,
      dateFormat: "",
      datapickClass: "form-control form-control-xs my-0",
      serviceTypes: [],
      serviceTypesIndex: [],
      ServiceTypes: [],
      SelectedServices: [],
      servicetypeindexes: [],
      SelectedSubTypes: [],
      servicesubtypeindexes: [],
      ServiceSubTypes: [],
      SubTypeNum: "",
      PACodes: [],
      PADurationCodes: [
        { id: "D", text: "Days" },
        { id: "M", text: "Months" },
        { id: "Y", text: "Years" },
        { id: "I", text: "Indefinite" },
      ],
      AgeDurationCodes: [
        { id: "M", text: "Months" },
        { id: "Y", text: "Years" },
      ],
      PurgeFrequencyCodes: [
        { id: "D", text: "Days" },
        { id: "M", text: "Months" },
        { id: "Y", text: "Years" },
        { id: "L", text: "Lifetime" },
      ],
      BillFrequencyCodes: [
        { id: "D", text: "Days" },
        { id: "M", text: "Months" },
        { id: "Y", text: "Years" },
        { id: "L", text: "Lifetime" },
        { id: "P", text: "Lifetime Provid" },
      ],
      PAReq: "NA",
      PADuration: " ",
      MinAge: "",
      MaxAge: "",
      PurgeFrequency: "",
      BillFrequency: "",
      GCCodes: [],
      GC: [],
      ShowDental: false,
      ShowNonDental: false,
      ShowCategoryPeriod: false,
      SpecialCategoryNum: [],
      SpecialCategory: "",
      isEffective: false,
      isExpired: false,
      showModal: false,
      succeeded: false,
      Msg: "",
      initial: true,
      filled: false,
      SubTypeKey: 0,
      ServiceKey: 0,
      TeethKey: 0,
      allowShip: true,
      addUserid: "",
      selected: [],
      selectedchkbox: [],
      tableData: [],
      STypecolumns: ["id", "text", "type"],
      STypeoptions: {
        filterable: false,
        headings: {
          id: "Select",
          text: "Service Type",
        },
      },
      SSubTypecolumns: ["id", "text", "type"],
      SSubTypeoptions: {
        filterable: false,
        headings: {
          id: "Select",
          text: "Service Sub Type",
        },
      },
      GCcolumns: ["id", "text"],
      GCoptions: {
        filterable: false,
        headings: {
          id: "Select",
          text: "Coverage",
        },
      },
      values: [
        { label: "Claim", value: "CL" },
        { label: "Prior Approval", value: "PA" },
      ],
      dkey: "0000000000000000",
    };
  },
  watch: {
    serviceCode() { },
    //   numUnitPriorApproval :function(val){
    //       alert(val)
    //      // this.numUnitPAval();
    //   },
    // SelectedSubTypes :function(val){
    //     console.log('selected val' , val);
    //     if(val.id == 1)
    //     {
    //     }
    //     },
  },
  created: function () {
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.mode = this.Mode;
    if (this.mode == "Add" || this.mode == "CloneAdd") {
      this.btnName = "Add Service Code";
      this.saveIcon = "fas fa-plus";
    } else if (this.mode == "Clone") {
      this.btnName = "Submit Service Code";

      this.saveIcon = "far fa-save";
    } else this.mode == "View";
    {
      this.viewOnly = true;
    }
    switch (this.mode) {
      case "Edit":
        this.populatewithHostData();
        this.GetTaxCodes();
        this.GetServiceTypes();
        this.GetLookupValue("PACODE");
        this.GetLookupValue("GCCODE");
        this.checkIfSuperuser().then(() => {
          this.DisableForm();
        });
        break;
      case "View":
        this.populatewithHostData();
        this.GetTaxCodes();
        this.GetServiceTypes();
        this.GetLookupValue("PACODE");
        this.GetLookupValue("GCCODE");
        //this.ViewServiceCode();
        this.DisableForm();
        this.dbkey = "0000000000000000";
        break;
      case "Clone":
        this.populatewithHostData();
        this.GetTaxCodes();
        this.GetServiceTypes();
        this.GetLookupValue("PACODE");
        this.GetLookupValue("GCCODE");
        this.DisableForm();
        this.dbkey = "0000000000000000";
        break;
      case "CloneAdd":
        this.populatewithHostData();
        this.GetTaxCodes();
        this.GetServiceTypes();
        this.GetLookupValue("PACODE");
        this.GetLookupValue("GCCODE");
        this.DisableForm();
        this.serviceCode = "";
        this.dbkey = "0000000000000000";
        break;
      case "Add":
        this.GetTaxCodes();
        this.GetServiceTypes();
        this.GetLookupValue("PACODE");
        this.GetLookupValue("GCCODE");
        this.AllowEdit = true;
        this.AllowEditExpiryDate = true;

        this.effectiveDate = moment()
          .add("days", 1)
          .format("YYYY/MM/DD");
        this.expiryDate = "9999/12/31";
        this.dbkey = "0000000000000000";
        this.disableSave = false;
    }
    this.allowShip = !this.codeIndShipRadio;
  },
  components: {
    Datepicker,
    ServiceCodeGRPSpecRate,
    ServiceCodePrereqServiceCodes,
    ServiceCodeSAIL,
    ServiceCodeToothNumberAllowed,
    ServiceCodeContradictory,
    RingLoader,
   RiseLoader, 
  },

  methods: {
    getScValue() {
      console.log("i m here");
      this.$refs.RefScContra.setValue(this.serviceCode);
    },
    DisableForm() {
      console.log("In DisableFormCheck");
      if (this.mode == "Clone") {
        this.AllowEdit = true;
        this.disableSave = false;
      } else if (this.mode == "View") {
        this.AllowEdit = false;
        this.disableSave = true;
        this.SetToothNoValues();
      } else if (this.mode == "Edit" && this.status == "ACTIVE") {
        if (!this.isSuper) {
          this.AllowEdit = false;
          console.log("Not SuperUser. Keeping fields locked.");
        }
        else {
          this.AllowEdit = true;
          console.log("Is SuperUser. Unlocking fields.");
        }
        this.SetToothNoValues();
        console.log("Edit/Act = " + this.AllowEdit);
        //if((moment(this.expiryDate)).toISOString() > moment().startOf('day').toISOString()){
        this.AllowEditExpiryDate = true;
        //}
        this.disableSave = false;
      } else if (this.mode == "Edit" && this.status == "FUTURE") {
        console.log("Edit/Fur");
        this.AllowEdit = true;
        this.disableSave = false;
      } else if (this.mode == "Edit" && this.status == "INACTIVE") {
        console.log("Edit/Inc");
        this.AllowEdit = false;
        this.SetToothNoValues();
        this.disableSave = true;
      } else if (this.mode == "CloneAdd") {
        this.AllowEdit = true;
        this.disableSave = false;
      }
    },
    PAReqChange() {
      if (this.PAReq != "NA") {
        //console.log('at change')
        this.numUnitPriorApproval = "";
        this.numUnitPriorApprovalFrequency = "";
      } else if (this.PAReq == "NA") {
        // console.log('at alter change')
        this.numUnitPriorApproval = "0";
        this.PADuration = " ";
        this.numUnitPriorApprovalFrequency = "0";
      }
    },
    SurchargeChange() {
      if (this.codeIndSurchargeRadio == true) {
        this.amtMaxSurcharge = "";
        this.pctMaxSurcharge = "";
      } else {
        this.amtMaxSurcharge = "0";
        this.pctMaxSurcharge = "0.000";
      }
    },
    GetTaxCodes() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetTaxCodes?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
        })
        .then(function (response) {
          // console.log("tax = " + response.data.id)
          vm.Taxes = response.data;
        })
        .catch(function (er) { });
    },
    ScPreReqFinish(ScPreRecTable) {
      //this.prerequisiteCodes = ScPreRecTable;
      //console.log(this.prerequisiteCodes);
    },
    ScContrCodeFinish(ScPreRecTable) {
      //this.prerequisiteCodes = ScPreRecTable;
      //console.log(this.prerequisiteCodes);
    },
    handleCategoryChange(e) {
      //  if (e.target.options.selectedIndex == 0)
      //  {
      //     this.nameCategory = 'N/A ';
      //     this.ShowCategoryPeriod = false;
      //     this.codeCategoryPeriod = 'N/A   ';
      //     this.SpecialCategory = 'N/A';
      //     this.numUnitCategory = 0
      //  }
      //  else
      //  {
      //      this.ShowCategoryPeriod = true;
      //     this.category = e.target.options.selectedIndex;
      //  }
    },
    handleCategoryPeriodChange(e) {
      //console.log("handleCategoryPeriodChange");
      //console.log("handleCategoryPeriodChange target: " + e.target.options.selectedIndex);
    },
    ClosePopup() {
      this.$root.$emit("bv::hide::modal", "AddModal", "#btnShow");
      //  this.$v.$reset();
    },

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          console.log("at value " + value);
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },



    SavePopup() {
      // if(SelectedServices.length)
      // {

      // }
      //console.log('v = ' + this.codeIndToothRadio)
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        var SelectedServiceids = this.SelectedServices.map((se) => se.type);
        var SelectedSubTypesids = this.SelectedSubTypes.map((se) => se.type);
        var retired;
        console.log("pa = " + this.PADuration);
        var GCPlansids = this.GC.map((se) => se.id);
        this.codePriorApproval = this.PAReq;
        if (this.PADuration != undefined && this.PADuration != " ") {
          this.codeUnitPADuration = this.PADuration.id;
          //console.log('codeUnitPADuration with undefined= ' + this.codeUnitPADuration)
        } else {
          this.codeUnitPADuration = "";
          //console.log('codeUnitPADuration = ' + this.codeUnitPADuration)
        }
        console.log(" expiry date = " + this.expiryDate);
        console.log(
          "Expiry after conversion  = " +
          moment(this.expiryDate, "YYYY-MM-DD").format("YYYY/MM/DD")
        );
        console.log(" retired before save = " + this.IsRetired);
        this.codeBillFreq = this.BillFrequency.id;
        //console.log(' Min age ID ' + this.MinAge.id)
        this.codeUnitAgeMin = this.MinAge.id;
        this.codeUnitAgeMax = this.MaxAge.id;
        this.codeUnitPurgeFrequency = this.PurgeFrequency.id;
        this.codeIndSurcharge = this.codeIndSurchargeRadio == true ? "Y" : "N";
        retired = this.IsRetired == true ? "Y" : "N";
        this.codeIndAttach = this.codeIndAttachRadio; //==true?'Y':'N';
        this.codeIndLTC = this.codeIndLTCRadio == true ? "Y" : "N";
        this.codeIndShip = this.codeIndShipRadio == true ? "Y" : "N";
        this.codeIndLetter = this.codeIndLetterRadio == true ? "Y" : "N";
        this.codeIndEDCElig = this.codeIndEDCEligRadio == true ? "Y" : "N";
        //console.log('numUnitCategory = ' + this.numUnitCategory)
        //this.numUnitCategory = this.SpecialCategory;// == undefined?'000':this.SpecialCategory.id;
        this.sailCodes = [{ prerequisite: "", PctDPPays: 0 }];
        if (this.ShowDental) {
          this.numTeeth = this.numTeeth == undefined ? [] : this.numTeeth;
        } else {
          this.numTeeth = [];
        }
        var vm = this;
       
        vm.disableSave = false;
        var url = "SaskHealthApi/Host/PostServiceCodeStandard/";
        var params = {
          _: Date.now(),
          AddUserid: vm.addUserid,
          ModifyUserId: vm.modifyUserId,
          ServiceCode: vm.serviceCode,
          TextDescription: vm.textDescription,
          EffectiveDate: vm.effectiveDate,
          ExpiryDate: moment(vm.expiryDate, "YYYY-MM-DD").format("YYYY/MM/DD"),
          ServiceTypes: SelectedServiceids,
          ServiceSubTypes: SelectedSubTypesids,
          MaxChargeAmt: vm.maxChargeAmt,
          grpSpecRates: vm.grpSpecRates,
          codePriorApproval: vm.codePriorApproval,
          codeUnitPADuration: vm.codeUnitPADuration,
          numUnitPriorApproval: vm.numUnitPriorApproval,
          numUnitPriorApprovalFrequency: vm.numUnitPriorApprovalFrequency,
          codeBillFreq: vm.codeBillFreq,
          numBillFreq: vm.numBillFreq,
          numQtyMaxBill: vm.numQtyMaxBill,
          codeUnitAgeMin: vm.codeUnitAgeMin,
          numAgeMin: vm.numAgeMin,
          codeUnitAgeMax: vm.codeUnitAgeMax,
          numAgeMax: vm.numAgeMax,
          codeCovPlans: GCPlansids,
          prerequisiteCodes: vm.prerequisiteCodes,
          codeIndSurcharge: vm.codeIndSurcharge, //check on API side
          pctMaxSurcharge: vm.pctMaxSurcharge,
          amtMaxSurcharge: vm.amtMaxSurcharge,
          codeIndAttach: vm.codeIndAttach, //check on API side
          codeIndLTC: vm.codeIndLTC,
          codeUnitPurgeFrequency: vm.codeUnitPurgeFrequency,
          numUnitPurgeFrequency: vm.numUnitPurgeFrequency,
          codeIndShip: vm.codeIndShip,
          amtChargeShipMax: vm.amtChargeShipMax,
          pctMaxMarkup: vm.pctMaxMarkup,
          codeTaxes: vm.codeTaxes,
          sailCodes: vm.sailCodes,
          codeIndTooth: vm.codeIndToothRadio,
          IsRetired: retired,
          numTeeth: vm.numTeeth,
          codeIndEDCElig: vm.codeIndEDCElig,
          contradictoryCodes: vm.contradictoryCodes,
          nameCategory: vm.nameCategory,
          numUnitCategory: vm.numUnitCategory,
          codeCategoryPeriod: vm.codeCategoryPeriod,
          codeIndLetter: vm.codeIndLetter,
          codeIndRegiem: vm.codeIndRegiem,
          mode: this.mode == "Edit" ? "U" : "A",
          dbkey: vm.dbkey,
        };
        axios({
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
          },
          data: params,
        })
          .then(function (response) {
            vm.succeeded = true;
            vm.Msg = "Service Code: " + vm.serviceCode + ": " + response.data;
            vm.showModal = true;
          })
          .catch(function (er) {
            if (er.response) {
              //console.log('Server responded with status code:', er.response.status);
              //console.log('Response data:', er.response.data.message);

              if(er.response.status == 400)
              {
                if( er.response.data.message.length)
                {
                  vm.showMsg(er.response.data.message,"","Service Code Error");

                }
              }


            }
           else
            //console.log('here')
                  vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");

           })
          .then(function () {
            vm.loading = false;
           });
      }
    },
    SetToothNoValues() {
      if (this.codeIndToothRadio == "1") {
        this.ToothReqValues = [
          { label: "None", value: "0", disabled: true },
          { label: "One", value: "1", disabled: false },
          { label: "One+", value: "9", disabled: true },
          { label: "Two +", value: "2", disabled: true },
        ];
      } else if (this.codeIndToothRadio == "2") {
        this.ToothReqValues = [
          { label: "None", value: "0", disabled: true },
          { label: "One", value: "1", disabled: true },
          { label: "One+", value: "9", disabled: true },
          { label: "Two +", value: "2", disabled: false },
        ];
      } else if (this.codeIndToothRadio == "0") {
        this.ToothReqValues = [
          { label: "None", value: "0", disabled: false },
          { label: "One", value: "1", disabled: true },
          { label: "One+", value: "9", disabled: true },
          { label: "Two +", value: "2", disabled: true },
        ];
      } else if (this.codeIndToothRadio == "9") {
        this.ToothReqValues = [
          { label: "None", value: "0", disabled: true },
          { label: "One", value: "1", disabled: true },
          { label: "One+", value: "9", disabled: false },
          { label: "Two +", value: "2", disabled: true },
        ];
      }
    },
    GetLookupValue(val) {
      var params = new URLSearchParams();
      var vm = this;
      if (val == "PACODE") {
        params.append("name", "PA Code");
        axios
          .get("SaskHealthApi/Codes/GetLookUpValues?_=" + Date.now(), {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.PACodes = response.data;
            // vm.PAReq = vm.PACodes.find(x=>x.id === vm.codePriorApproval);
            // console.log(vm.PAReq);
          })
          .catch(function (er) {
            console.log(er);
          });
      } else if (val == "GCCODE") {
        params = new URLSearchParams();
        params.append("name", "GC Code");
        axios
          .get("SaskHealthApi/Codes/GetLookUpValues?_=" + Date.now(), {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.GCCodes = response.data;
          })
          .catch(function (er) {
            console.log(er);
          })
          .then(function () {
            if (vm.codeCovPlans.length > 0) {
              _.forEach(vm.codeCovPlans, function (value, key) {
                //console.log(value)
                vm.GC.push(vm.GCCodes.find((x) => x.id === value));
              });
            }
          });
      }
    },
    GetSubTypes() {
      var vm = this;
      var SelectedServiceids = vm.SelectedServices.map((se) => se.id);
      //console.log(SelectedServiceids)
      vm.SubTypeKey++;
      var params = new URLSearchParams();
      params.append("ServiceID", SelectedServiceids);
      axios
        .get("SaskHealthApi/Codes/GetServiceSubtypesCombo?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.ServiceSubTypes = response.data.items;
        })
        .catch(function (er) { })
        .then(function () {
          if (vm.ObjServiceCode.serviceSubTypes.length > 0) {
            _.forEach(vm.ObjServiceCode.serviceSubTypes, function (value, key) {
              vm.SelectedSubTypes.push(
                vm.ServiceSubTypes.find((x) => x.type === value)
              );
            });
            vm.SubTypeKey++;
            vm.SubTypeNum = vm.ServiceSubTypes.length;
            vm.grpSpecRates.forEach(function (e) {
              if (typeof e === "object" && e["desc"] == undefined) {
                e["desc"] = vm.ServiceSubTypes.find(
                  (x) => x.type == e.codeSpecType
                ).text;
              }
            });
            vm.filled = true;
          }
        });
    },
    GetServiceTypes() {
      var vm = this;
      axios
        .get(
          "SaskHealthApi/Codes/GetServicesComboWithoutDPEBB?_=" + Date.now(),
          { headers: { Authorization: "Bearer " + localStorage.access_token } }
        )
        .then(function (response) {
          console.log("service types " + response.data.items);
          vm.ServiceTypes = response.data.items;
        })
        .catch(function (er) {
          console.log(er);
        })
        .then(function () {
          vm.ServiceKey++;
          if (
            vm.ObjServiceCode.serviceTypes != undefined &&
            vm.ObjServiceCode.serviceTypes.length > 0
          ) {
            _.forEach(vm.ObjServiceCode.serviceTypes, function (value, key) {
              vm.SelectedServices.push(
                vm.ServiceTypes.find((x) => x.type === value)
              );
              if (value == "DEN") {
                vm.ShowDental = true;
              } else {
                vm.ShowNonDental = true;
              }
            });
          }
          if (
            vm.ObjServiceCode.serviceSubTypes != undefined &&
            vm.ObjServiceCode.serviceSubTypes.length > 0
          ) {
            vm.GetSubTypes();
          }
        });
    },
    AddServiceCode() {
      //console.log("Prop Service Code :: "+this.ObjServiceCode);
      this.disableSave = false;
      this.viewOnly = false;

      this.effectiveDate = moment()
        .add("days", 1)
        .format("YYYY/MM/DD");
      this.expiryDate = "9999/12/31";
      this.dbkey = "0000000000000000";
    },
    changedServiceTypechkbox() {
      //console.log("selected servicetype: " + this.SelectedServices);
      var vm = this;
      vm.ShowDental = false;
      vm.ShowNonDental = false;
      vm.grpSpecRates.splice(0, vm.grpSpecRates.length);
      vm.contradictoryCodes.splice(0, vm.contradictoryCodes.length);
      vm.prerequisiteCodes.splice(0, vm.prerequisiteCodes.length);
      _.forEach(this.SelectedServices, function (value, key) {
        //  console.log('value = ' + value.type);
        if (value.id == 1) {
          //vm.codeIndSurchargeRadio = true;
          vm.ShowDental = true;
        } else {
          vm.ShowNonDental = true;
        }
      });
      this.initial = false;
      this.ServiceKey++;
      this.fillSubTypeschkbox();
    },
    populatewithHostData() {
      this.ObjServiceCode = this.PropServiceCode;
      this.dbkey = this.ObjServiceCode.dbkey;
      this.addUserid = this.ObjServiceCode.addUserid;
      this.createdDate = this.ObjServiceCode.addDate;
      this.createdDate = moment(this.createdDate, "YYYYMMDDhhmmss").format(
        "YYYY/MM/DD"
      );
      this.modifyUserId = this.$store.getters.GetCurrentUser.toUpperCase();
      this.lastmodifiedDate = this.ObjServiceCode.modifyDate;
      this.lastmodifiedDate = moment(
        this.lastmodifiedDate,
        "YYYYMMDDhhmmss"
      ).format("YYYY/MM/DD");
      this.codeIndRegiem = "N"; //For Future use - Placeholder
      this.serviceCode = this.ObjServiceCode.serviceCode;
      console.log("Desc = " + this.ObjServiceCode.textDescription.trim());
      this.textDescription = this.ObjServiceCode.textDescription.trim();
      this.effectiveDate = this.ObjServiceCode.effectiveDate;
      this.expiryDate = this.ObjServiceCode.expiryDate;
      console.log("service ttypes  = " + this.ObjServiceCode.serviceTypes);
      this.serviceTypes = this.ObjServiceCode.serviceTypes;
      this.serviceTypesIndex = this.ObjServiceCode.serviceTypesIndex;
      this.serviceSubTypes = this.ObjServiceCode.serviceSubTypes;
      this.serviceSubTypesIndex = this.ObjServiceCode.serviceSubTypesIndex;
      //console.log(this.ObjServiceCode.maxChargeAmt)
      this.maxChargeAmt = this.ObjServiceCode.maxChargeAmt;
      this.grpSpecRates = this.ObjServiceCode.grpSpecRates;
      this.PAReq = this.ObjServiceCode.codePriorApproval;
      this.codeBillFreq = this.ObjServiceCode.codeBillFreq;
      //console.log("PADuration from MF = " + this.ObjServiceCode.codeUnitPADuration)
      if (this.ObjServiceCode.codeUnitPADuration == " ") {
        //console.log(' in IF')
        this.PADuration = " ";
      } else {
        //console.log(' in ELSE')
        //var f = _.find(this.PADurationCodes, ['id', this.ObjServiceCode.codeUnitPADuration]);
        //var f = _.find(this.PADurationCodes, ['id', 'M']);
        //console.log('Lodash find ')
        // _.forEach(f, function(value) {
        // console.log(value);
        // });
        this.PADuration = this.PADurationCodes.find(
          (x) => x.id == this.ObjServiceCode.codeUnitPADuration
        );
        //   console.log("Pad Duration Value " + this.PADuration.id)
        // _.forEach(this.PADuration, function(value) {
        // console.log("PA value = "+value);
        //});
      }
      //console.log("this.PADuration = " + this.PADuration[0])
      //console.log("Duration find " + this.PADurationCodes.find(x=>x.id == this.ObjServiceCode.codeUnitPADuration))
      this.numUnitPriorApproval = this.ObjServiceCode.numUnitPriorApproval;
      this.numUnitPriorApprovalFrequency = this.ObjServiceCode.numUnitPriorApprovalFrequency;
      console.log(
        "at created numunitpafrequency = " +
        this.ObjServiceCode.numUnitPriorApprovalFrequency
      );
      this.numBillFreq = this.ObjServiceCode.numBillFreq;
      this.numQtyMaxBill = this.ObjServiceCode.numQtyMaxBill;
      console.log("min age = " + this.ObjServiceCode.codeUnitAgeMin);
      this.codeUnitAgeMin = this.ObjServiceCode.codeUnitAgeMin;
      this.numAgeMin = this.ObjServiceCode.numAgeMin;
      this.codeUnitAgeMax = this.ObjServiceCode.codeUnitAgeMax;
      console.log("Max age = " + this.ObjServiceCode.codeUnitAgeMax);
      this.numAgeMax = this.ObjServiceCode.numAgeMax;
      //console.log('plans : ' + this.ObjServiceCode.codeCovPlans);
      this.codeCovPlans = this.ObjServiceCode.codeCovPlans;
      this.prerequisiteCodes = this.ObjServiceCode.prerequisiteCodes;
      this.codeIndSurchargeRadio =
        this.ObjServiceCode.codeIndSurcharge == "Y" ? true : false;

      console.log("is Retired = " + this.ObjServiceCode.isRetired);
      this.IsRetired = this.ObjServiceCode.isRetired == "Y" ? true : false;

      //console.log("Max surcharge " + this.ObjServiceCode.pctMaxSurcharge)
      this.pctMaxSurcharge = this.ObjServiceCode.pctMaxSurcharge;
      this.amtMaxSurcharge = this.ObjServiceCode.amtMaxSurcharge;
      this.codeIndAttachRadio = this.ObjServiceCode.codeIndAttach; //=='Y'?true:false;
      console.log(" Atch Host = " + this.codeIndAttachRadio);
      this.codeIndLTCRadio =
        this.ObjServiceCode.codeIndLTC == "Y" ? true : false;
      //console.log('Purge Freq =  Issue in code NEED L in array of purge frequency ' + this.ObjServiceCode.codeUnitPurgeFrequency)
      this.codeUnitPurgeFrequency = this.ObjServiceCode.codeUnitPurgeFrequency;
      this.numUnitPurgeFrequency = this.ObjServiceCode.numUnitPurgeFrequency;
      //this.codeIndToothRadio =this.ObjServiceCode.codeIndTooth=='Y'?true:false;
      this.codeIndToothRadio = this.ObjServiceCode.codeIndTooth;
      this.numTeeth = this.ObjServiceCode.numTeeth;
      this.codeIndEDCEligRadio =
        this.ObjServiceCode.codeIndEDCElig == "Y" ? true : false;
      this.contradictoryCodes = this.ObjServiceCode.contradictoryCodes;
      //console.log('contradictoryCodes = ' + this.contradictoryCodes.length);
      this.nameCategory =
        this.ObjServiceCode.nameCategory.trim() == ""
          ? " "
          : this.ObjServiceCode.nameCategory;
      if (this.nameCategory != "N/A ") {
        this.ShowCategoryPeriod = true;
      }
      //console.log('ObjServiceCode numUnitCategory = ' + this.ObjServiceCode.numUnitCategory)
      this.numUnitCategory = this.ObjServiceCode.numUnitCategory;
      this.codeCategoryPeriod =
        this.ObjServiceCode.codeCategoryPeriod.trim() == ""
          ? " "
          : this.ObjServiceCode.codeCategoryPeriod;
      this.codeIndLetterRadio =
        this.ObjServiceCode.codeIndLetter == "Y" ? true : false;
      this.codeIndShipRadio =
        this.ObjServiceCode.codeIndShip == "Y" ? true : false;
      //console.log('MF CategoryPeriod = ' + this.codeCategoryPeriod);
      this.pctMaxMarkup = this.ObjServiceCode.pctMaxMarkup;
      this.amtChargeShipMax = this.ObjServiceCode.amtChargeShipMax;
      this.codeTaxes = this.ObjServiceCode.codeTaxes;
      this.sailCodes = this.ObjServiceCode.sailCodes;

      this.isExpired =
        moment(this.expiryDate).toISOString() <=
        moment()
          .startOf("day")
          .toISOString();

      this.isEffective =
        moment(this.effectiveDate).toISOString() <=
        moment()
          .startOf("day")
          .toISOString();
      //console.log("Code Unit Min age = " + this.codeUnitAgeMin)
      this.MinAge = this.AgeDurationCodes.find(
        (x) => x.id == this.codeUnitAgeMin
      );
      // console.log(" Min age = " + this.MinAge)
      this.MaxAge = this.AgeDurationCodes.find(
        (x) => x.id == this.codeUnitAgeMax
      );
      this.PurgeFrequency = this.PurgeFrequencyCodes.find(
        (x) => x.id == this.codeUnitPurgeFrequency
      );
      this.BillFrequency = this.BillFrequencyCodes.find(
        (x) => x.id == this.codeBillFreq
      );
      //console.log('affect ' + this.isEffective);
      //console.log('expiry ' + this.isExpired);
      // this.SelectedSubTypes = this.ObjServiceCode.serviceSubTypes;
    },

    fillSubTypeschkbox() {
      var vm = this;
      var params = new URLSearchParams();
      console.log(this.SelectedServices);
      if (this.SelectedServices.length > 0) {
        var SelectedServiceids = this.SelectedServices.map((se) => se.id);
        params.append("ServiceID", SelectedServiceids);
        axios
          .get("SaskHealthApi/Codes/GetServiceSubtypesCombo?_=" + Date.now(), {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.ServiceSubTypes = response.data.items;
            vm.SelectedSubTypes = [];
            if (vm.initial) {
              for (var i = 0; i < vm.serviceSubTypes.length; i++) {
                vm.SelectedSubTypes.push(
                  vm.ServiceSubTypes.find(
                    (x) => x.type === vm.serviceSubTypes[i]
                  )
                );
              }
            }
            vm.SubTypeKey++;
            vm.SubTypeNum = vm.ServiceSubTypes.length;
            vm.grpSpecRates.forEach(function (e) {
              if (typeof e === "object" && e["desc"] == undefined) {
                e["desc"] = vm.ServiceSubTypes.find(
                  (x) => x.type == e.codeSpecType
                ).text;
              }
            });
            vm.filled = true;
          })
          .catch(function (er) { });
      } else {
        vm.ServiceSubTypes = [];
      }
    },
    changedSubTypeschkbox() {
      for (var i = 0; i < this.grpSpecRates.length; i++) {
        if (
          this.SelectedSubTypes.findIndex(
            (x) => x.type == this.grpSpecRates[i].codeSpecType
          ) == -1
        )
          this.grpSpecRates.splice(i, 1);
      }
      this.SubTypeKey++;
    },
    ServiceCodeExit() {
      this.showModal = false;
      if (this.succeeded) {
        this.$emit("ServiceCodeExit");
      }
    },
    ShippingChange() {
      if (this.codeIndShipRadio) this.amtChargeShipMax = "";
      else this.amtChargeShipMax = 0;
      this.allowShip = !this.codeIndShipRadio;
    },
    changedToothRequired() {
      //console.log(' Teeth Key ' + this.numTeeth.length)
      this.TeethKey++;
      this.numTeeth.splice(0, this.numTeeth.length);
    },
    numPAReqVal() {
      if (this.PAReq == "NA") {
        return true;
      } else if (this.PAReq != "NA") {
        //alert(this.numUnitPriorApproval.length)
        console.log("this.numUnitPriorApproval = " + this.numUnitPriorApproval);
        if (this.numUnitPriorApproval.length == 0) return false;
        else return true;
      } else return true;
    },
    numUnitPAval() {
      if (this.PAReq != "NA") {
        //console.log('at SC num before prior approval')
        if (
          this.numUnitPriorApproval !== "" &&
          (this.numUnitPriorApproval !== null ||
            this.numUnitPriorApproval !== undefined)
        ) {
          if (!this.Valnum(this.numUnitPriorApproval)) {
            // console.log('not passed = ' +this.numUnitPriorApproval)
            return false;
          } else {
            return true;
          }

          // if(!parseInt(this.numUnitPriorApproval))
          // return false;
          // else
          // {
          //     if(this.numUnitPriorApproval == 0)
          //     return true;
          //     else if(!this.Valnum(this.numUnitPriorApproval))
          //     {
          //         return false;
          //     }
          //     else
          //     return true;
          // }
          //return true;
        } else return false;
      } else {
        return true;
      }
    },
    numUnitPAFreq() {
      if (this.PAReq != "NA") {
        console.log(
          " numUnitPriorApprovalFrequency value = " +
          this.numUnitPriorApprovalFrequency
        );
        // if (
        //    this.numUnitPriorApprovalFrequency !== "" )
        // {
        if (
          this.numUnitPriorApprovalFrequency !== "" &&
          (this.numUnitPriorApprovalFrequency !== null ||
            this.numUnitPriorApprovalFrequency !== undefined)
        ) {
          //                 if(!parseInt(this.numUnitPriorApproval))
          // return false;
          // else
          // {
          //     if(this.numUnitPriorApproval == 0)
          //     return true;
          //     else if(!this.Valnum(this.numUnitPriorApproval))
          //     {
          //         return false;
          //     }
          //     else
          //     return true;
          // }

          //console.log("not passed");
          if (!this.Valnum(this.numUnitPriorApprovalFrequency)) {
            //console.log("passed = " + this.numUnitPriorApprovalFrequency);
            //console.log("value = " + this.numUnitPriorApprovalFrequency);
            return false;
          } else return true;
        } else {
          console.log(" not zero");
          return false;
        }
      } else {
        return true;
      }
    },
    PADurationLengthVal() {
      // _.forEach(this.PADuration, function(value) {
      // console.log("PA loop = "+value);
      // });
      //console.log("PADuration validation = " +this.PADuration)
      if (this.PAReq != "NA") {
        if (
          this.PADuration != undefined &&
          (this.PADuration.length == 0 || this.PADuration == " ")
        ) {
          //  console.log('PA False')
          return false;
        } else {
          //console.log('PA True')
          return true;
        }
      } else {
        return true;
      }
    },
    ValOneVFour: function (val) {
      var OneVFour = /^[0-2]{0,1}(\.[0-2]{1,3})?$/;
      return OneVFour.test(val);
    },
    Valnum: function (val) {
      var num = /^[0-9]{1,3}$/;
      console.log("value numeric  = " + num.test(val));
      return num.test(val);
    },
    ValSixVTwo: function (val) {
      var SixVTwo = /^[0-9]{0,6}(\.[0-9]{1,2})?$/;
      return SixVTwo.test(val);
    },
    ValOneVThree: function (val) {
      var OneVThree = /^1{1}(\.[0]{1,3})?$|^0{0,1}(\.[0-9]{1,3})?$/;
      return OneVThree.test(val);
    },
    pctMaxSurchargeVal() {
      // _.forEach(this.pctMaxSurcharge, function(value) {
      // console.log("Max Surcharge = "+value);
      // });
      console.log("this.pctMaxSurcharge.length  = " + this.pctMaxSurcharge);
      if (this.codeIndSurchargeRadio == true) {
        console.log("here");
        if (this.pctMaxSurcharge.length == 0) return false;
        else if (!this.ValOneVThree(this.pctMaxSurcharge)) return false;
        else return true;
      } else {
        return true;
      }
    },
    amtMaxSurchargeVal() {
      console.log("her");
      _.forEach(this.amtMaxSurcharge, function (value) {
        //console.log("amt Max Surcharge = "+value);
      });
      if (this.codeIndSurchargeRadio == true) {
        // console.log(" this.amtMaxSurcharge.length "  + this.amtMaxSurcharge.length)
        if (this.amtMaxSurcharge.length == 0) return false;
        else if (!this.ValSixVTwo(this.amtMaxSurcharge)) return false;
        else return true;
      } else {
        return true;
      }
    },
    //HDP4562 Service Code Edit Addition
    checkIfSuperuser() {
      var params = new URLSearchParams();
      var vm = this;
      return axios.get('SaskHealthApi/Codes/IsSuperUser', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
        .then(function (response) {
          vm.isSuper = response.data;
          console.log("SuperUser Check: " + vm.isSuper);
        }).catch(function (er) {
          console.log(er)
        });
    }
  },
  validations() {
    return {
      SelectedServices: {
        needValue: value =>   (this.SelectedServices.length>0)
      },
      SelectedSubTypes: {
        required: requiredIf(function () {
          
          if(this.SelectedServices.length)
          {
            if (!this.SelectedSubTypes.length)
            return true;
            else
            return false;
          }
          else
          {
              return false
          }
        }),

      },
      serviceCode: {
        //more validation required
        required,
        maxLength: maxLength(10),
      },
      textDescription: {
        required,
        maxLength: maxLength(128),
      },
      effectiveDate: {
        required,
      },
      expiryDate: {
        required,
        //moment(vm.expiryDate, "YYYY-MM-DD").format('YYYY/MM/DD')
        //minValue1: value => (moment(this.expiryDate, "YYYY-MM-DD")).toISOString() >=  moment().startOf('day').toISOString(),
        //minValue2: value => (moment(this.expiryDate, "YYYY-MM-DD")).toISOString() >= (moment(this.effectiveDate)).toISOString()
        //minValue1: value => (moment(this.expiryDate)).toISOString() >=  moment().startOf('day').toISOString(),
        ///minValue2: value => moment(this.expiryDate).toISOString() >= (moment(this.effectiveDate)).toISOString()
      },
      maxChargeAmt: {
        required,
        SixvTwo,
      },
      numUnitPriorApproval: {
        Valrequired: (value) => this.numUnitPAval(),
        //numeric
      },
      PADuration: {
        Valrequired: (value) => this.PADurationLengthVal(),
        //numeric
      },
      numUnitPriorApprovalFrequency: {
        Valrequired: (value) => this.numUnitPAFreq(),
        numeric,
      },
      numUnitCategory: {
        required,
        numeric,
      },

      numBillFreq: {
        required,
        numeric,
      },
      GC: {
        required,
        //Valrequired : value => (this.GC.length ==0?false:true),
      },
      BillFrequency: {
        Valrequired : value => (this.BillFrequency.length ==0?false:true),
      },
      PurgeFrequency: {
        Valrequired: (value) =>
          this.PurgeFrequency.length == 0 ? false : true,
      },
      numUnitPurgeFrequency: {
        required,
        numeric,
      },
      numQtyMaxBill: {
        required,
        numeric,
      },
      MinAge: {
        Valrequired: (value) => (this.MinAge.length == 0 ? false : true),
      },
      MaxAge: {
        Valrequired: (value) => (this.MaxAge.length == 0 ? false : true),
      },
      numAgeMin: {
        required,
        numeric,
      },
      numAgeMax: {
        required,
        numeric,
      },
      pctMaxSurcharge: {
        Valrequired: (value) => this.pctMaxSurchargeVal(),
        OnevThree,
      },
      amtMaxSurcharge: {
        Valrequired: (value) => this.amtMaxSurchargeVal(),
        SixvTwo,
      },
      amtChargeShipMax: {
        SixvTwo,
        amtChargeShipMaxNeeded: (value) =>
          !this.codeIndShipRadio ||
          (this.amtChargeShipMax != undefined && this.amtChargeShipMax != ""),
      },
      pctMaxMarkup: {
        needValue: (value) =>
          this.pctMaxMarkup != undefined || this.pctMaxMarkup != "",
        OnevThree,
      },
    };
  },
};
</script>

<style scoped>
.btn {
  outline: none !important;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}

input[type="radio"].with-font,
input[type="checkbox"].with-font {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* input[type=radio].with-font ~ label:before, */
input[type="checkbox"].with-font~label:before {
  /* font-family: FontAwesome; */
  display: inline-block;
  content: "\f1db";
  letter-spacing: 7px;
  font-size: 1em;
  color: #535353;
  width: 1.2em;
}

input[type="radio"].with-font:checked~label:before,
input[type="checkbox"].with-font:checked~label:before {
  content: "\f00c";
  font-size: 1.2em;
  color: darkgreen;
  letter-spacing: 5px;
}

input[type="checkbox"].with-font~label:before {
  content: "\f096";
}

input[type="checkbox"].with-font:checked~label:before {
  content: "\f046";
  color: darkgreen;
}

input[type="radio"].with-font:focus~label:before,
input[type="checkbox"].with-font:focus~label:before,
input[type="radio"].with-font:focus~label,
input[type="checkbox"].with-font:focus~label {
  color: green;
  vertical-align: text-top;
}

.checkbox label:after {
  content: "";
  display: table;
  clear: both;
}

.checkbox .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.2em;
  height: 1.2em;
  /* float: left; */
  margin-right: 0.5em;
}

.checkbox .cr .cr-icon {
  position: absolute;
  font-size: 0.7em;
  line-height: 0;
  top: 50%;
  left: 15%;
}

.checkbox label input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"]+.cr>.cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled+.cr {
  opacity: 0.5;
}

#ServiceCodeAddEdit .VuePagination__count {
  visibility: hidden;
  height: 0px;
}

#ServiceCodeAddEdit .pagination {
  height: 0px;
}

#ServiceCodeAddEdit .test-modal .modal-dialog {
  max-width: 50%;
  margin: 0;
  top: 7%;
  bottom: 0;
  left: 25%;
  right: 0;
  height: 30vh;
  display: flex;
  /* position: fixed; */
  z-index: 100000;
}
</style>
